import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from 'context/languageContext';
import { ThemeProvider } from 'context/themeContext';

import './resources/styles/core/root.scss';
import { HelmetProvider } from 'react-helmet-async';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('../firebase-messaging-sw.js')
    .then(registration => {
      //console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch(error => {
      false && console.error('Service Worker registration failed:', error);
    });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <LanguageProvider>
      <ThemeProvider>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </ThemeProvider>
    </LanguageProvider>
  </Provider>,
);
reportWebVitals((e) => {
  //if (e.rating !== 'good') console.error(e);
});
